// extracted by mini-css-extract-plugin
export default {"menu-item__content":"menuItem_menu-item__content__Hb9el"};